import request from '@/utils/request'

const ASSET_API_PREFIX = '/api/attachment'

/**
 * 按文件夹 code 获取分页资产列表，排序由服务端执行。
 */
export function getAssetList(data = {}, options = {}) {
  return request({
    url: `${ASSET_API_PREFIX}/asset_list`,
    method: 'get',
    params: data,
    ...options
  })
}

/**
 * 上传资产文件。
 *
 * The backend accepts one file per request. Keep the optional callback in the
 * API layer so callers can expose upload progress without reaching into axios.
 */
export function uploadAsset(data, uploadProgress) {
  const multipart = typeof FormData !== 'undefined' && data instanceof FormData
  const onUploadProgress = typeof uploadProgress === 'function'
    ? uploadProgress
    : undefined

  return request({
    url: `${ASSET_API_PREFIX}/asset_upload`,
    method: 'post',
    data,
    headers: multipart ? {'Content-Type': 'multipart/form-data'} : undefined,
    onUploadProgress,
    timeout: 120000
  })
}

/**
 * 重命名资产文件。
 */
export function renameAsset(data) {
  return request({
    url: `${ASSET_API_PREFIX}/file/rename`,
    method: 'post',
    data
  })
}

/**
 * 将一个或多个资产移动到目标文件夹 code。
 */
export function moveAssets(data) {
  return request({
    url: `${ASSET_API_PREFIX}/file/move`,
    method: 'post',
    data
  })
}

/**
 * 删除一个或多个资产文件。
 */
export function deleteAssets(data) {
  return request({
    url: `${ASSET_API_PREFIX}/file/delete`,
    method: 'post',
    data
  })
}

/**
 * 获取单个资产的缩略图、完整预览或下载签名地址。
 */
export function getAssetAccessUrl(data, options = {}) {
  return request({
    url: `${ASSET_API_PREFIX}/file/access_url`,
    method: 'post',
    data,
    ...options
  })
}

/**
 * 分页获取当前用户、当前团队下的文件夹列表。
 */
export function getAssetFolderList(data = {}, options = {}) {
  return request({
    url: `${ASSET_API_PREFIX}/folder/list`,
    method: 'get',
    params: data,
    ...options
  })
}

/**
 * 创建资产文件夹。
 */
export function createAssetFolder(data) {
  return request({
    url: `${ASSET_API_PREFIX}/folder/create`,
    method: 'post',
    data
  })
}

/**
 * 重命名资产文件夹。
 */
export function renameAssetFolder(data) {
  return request({
    url: `${ASSET_API_PREFIX}/folder/rename`,
    method: 'post',
    data
  })
}

export function updateAssetFolderVisibility(data) {
  return request({
    url: `${ASSET_API_PREFIX}/folder/visibility`,
    method: 'post',
    data
  })
}

/**
 * 删除资产文件夹。
 */
export function deleteAssetFolder(data) {
  return request({
    url: `${ASSET_API_PREFIX}/folder/delete`,
    method: 'post',
    data
  })
}
